<template>
  <div class="certification">
    <img src="@/assets/img/pages/reviews/immodvisor.png" alt="Immodvisor">
    <span>
      <img class="logo" src="@/assets/logos/logo-black.svg" alt="Maisons Alysia">
      <small>{{ text }}</small>
    </span>
    <span class="rate">
      <strong>{{ rating }}</strong> <small>/&nbsp;5</small>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ReviewCertification',
  props: {
    text: {
      type: String,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="sass">
.certification
  display: flex
  gap: 10px
  align-items: center
  justify-content: space-between
  margin: 10px 0
  padding: 20px
  background: white
  box-shadow: $drop-shadow
  border-radius: 20px
  @media (max-width: 768px)
    flex-direction: column
  > img
    height: 100px
  img.logo
    height: 60px
  > span
    display: flex
    flex-direction: column
    gap: 2px
    align-items: center
    justify-content: center
    small
      font-weight: bold
      color: $black
      text-transform: uppercase
  .rate
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    gap: 5px
    width: 100px
    height: 100px
    font-size: 1.8rem
    border-radius: 50%
    color: $primary
    strong
      font-size: 3.8rem
    small
      padding-top: 15px
      padding-right: 5px
      min-width: 40px
      color: $black
</style>
